
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Professions réglementées : guide des bonnes pratiques pour communiquer sur Internet",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Tout professionnel doit communiquer sur Internet à l’heure du numérique. Comment faire dans le cadre d’une activité professionnelle réglementée ? Cet article vous explique tout !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Professions réglementées : guide des bonnes pratiques pour communiquer sur Internet",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Tout professionnel doit communiquer sur Internet à l’heure du numérique. Comment faire dans le cadre d’une activité professionnelle réglementée ? Cet article vous explique tout !",
        },
      ],
    };
  },
};
